import "core-js/modules/es.array.concat.js";
import { getReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/tenant");
export var getTenantConfig = function getTenantConfig(name) {
  return getReq("".concat(BASE_URL, "/").concat(name));
};